import { Stack, TextField, Typography } from '@mui/material';

import { MinStockValuesDto } from '@gozoki/api';

const inputProps = { inputProps: { min: 0 } };

export interface DailySalesTextFieldProps {
    edit: boolean;
    editValues: MinStockValuesDto;
    minStockValues: MinStockValuesDto;
    setEditValues: (values: MinStockValuesDto) => void;
    dayKey: keyof MinStockValuesDto;
}

const DailySalesTextField = (props: DailySalesTextFieldProps) => {
    const { edit, editValues, minStockValues, setEditValues, dayKey } = props;

    const isLastColumn = dayKey === 'weekEndMinimumStock';

    const textFieldStyle = {
        bgcolor: 'white',
        width: isLastColumn ? '200%' : '100',
        minWidth: '100px',
    };

    if (dayKey === 'sundayMinimumStock') {
        return <Stack flex={1}>{edit ? null : <Typography>X</Typography>}</Stack>;
    }

    return (
        <Stack flex={1} position="relative" key={dayKey}>
            {edit ? (
                <>
                    <TextField
                        sx={textFieldStyle}
                        InputProps={inputProps}
                        value={editValues[dayKey]}
                        placeholder={minStockValues.mondayMinimumStock?.toString()}
                        type="number"
                        onChange={(e) =>
                            setEditValues({
                                ...editValues,
                                [dayKey]: Number.parseInt(e.target.value, 10),
                            })
                        }
                    />
                    {minStockValues[dayKey] !== editValues[dayKey] ? (
                        <Typography
                            color="text.secondary"
                            sx={{
                                fontSize: '12px',
                                position: 'absolute',
                                bottom: '1%',
                                left: isLastColumn ? '175%' : '75%',
                            }}
                        >
                            {`(${minStockValues[dayKey]})`}
                        </Typography>
                    ) : null}
                </>
            ) : (
                <Typography>{minStockValues[dayKey]}</Typography>
            )}
        </Stack>
    );
};

export default DailySalesTextField;
